import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelDeliveryReasonMiniEntity } from '../../domain/entities/CancelDeliveryReasonMiniEntity'
import type { CancelDeliveryReasonAdminListedDtoAdmin } from '@/backend/market'

export class CancelDeliveryReasonMiniModel extends CancelDeliveryReasonMiniEntity {
  constructor(dataDto: CancelDeliveryReasonAdminListedDtoAdmin) {
    super()
    mapEntityProperties<CancelDeliveryReasonMiniEntity>(this, dataDto)
  }
}

